<div id="main" class="external">
  <div id="login" class="section">
    <div class="content-body">
      <div class="title">
        <h1>{{ "login.title" | translate }}</h1>
      </div>
      @if (wrongInput) {
        <small class="p-error">{{ "login.invalid_credentials" | translate }}</small>
      }
      <div class="buttons">
        <button class="costa-button" type="submit" (click)="signIn()">
          {{ "login.title" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
